import React, { useState } from "react";
import { useNavigate, NavigateFunction } from "react-router-dom";
import { Alert, Button, Icon } from "antd";
import ConfirmCancellation from "../Sales/ConfirmCancellation";
import "./UserAccountForm.less";


type Props = {
    onSendCancellationReason: (reason: string, comment: string) => void;
    onDeleteUserAccount: (navigate: NavigateFunction) => void;
    isDeletingUserAccount: boolean;
}


export const DeleteAccount = ({ onDeleteUserAccount, onSendCancellationReason, isDeletingUserAccount }: Props) => {
    const navigate = useNavigate();
    const [cancellationReasonModalVisible, setCancellationReasonModalVisible] = useState(false);
    const toggleCancellationReasonModal = () => {
        setCancellationReasonModalVisible(!cancellationReasonModalVisible);
    };

    const deleteAccount = (reason: string, comment: string) => {
        onSendCancellationReason(reason, comment);
        onDeleteUserAccount(navigate);
    };

    const openCancellationReasonModal = () => {
        setCancellationReasonModalVisible(true);
    };

    return (
        <div className="user-account-card delete-user">
            <Alert
                message="Please note!"
                description="After deleting your account, you will not be able to use our services: your subscription will be canceled and your
          content, saved reports and other personal information will be erased."
                type="error"
                icon={<Icon type="warning" />}
                showIcon
            />

            <ConfirmCancellation
                title="Confirm delete account"
                visible={cancellationReasonModalVisible}
                showInfo={false}
                onClose={toggleCancellationReasonModal}
                onConfirmCancellation={(reason: string, comment: string) => deleteAccount(reason, comment)}
                loading={isDeletingUserAccount}
            />

            <Button type="primary" onClick={openCancellationReasonModal}>
                Delete Account
            </Button>
        </div>
    );
};

export default DeleteAccount;
